import React from "react";
import { Facebook, Linkedin, Twitter } from "react-bootstrap-icons";
import "../../styles/AboutProfilemodule.css";

const AboutProfilemodule = ({
  image,
  pageTitle,
  designation,
  description,
  fblink,
  linkdin,
  twitter,
}) => {
  return (
    <div className="row g-0 p-5">
      {/* About Us Section */}
      <div className="col-md-4">
        <div className="circle-container">
          <div className="circle yellow"></div>
          <div className="circle gray"></div>

          <div className="profile">
            <img src={image} alt="Profile" />
          </div>
        </div>
      </div>

      {/* Contact Us Section */}
      <div className="col-md-8">
        <p className="p title">{pageTitle}</p>
        <p className="underline font-family text-secondary">
          {designation}
        </p>

        <p className="font-family text-secondary sub-title">
          {description}
        </p>

        {/* Social Icons */}
        <div className="mt-3">
          {fblink && (
            <a
              href={fblink}
              className="text-light me-3 text-secondary"
              target="_blank"
              rel="noreferrer"
            >
              <Facebook size={28} />
            </a>
          )}

          {linkdin && (
            <a
              href={linkdin}
              className="text-light me-3 text-secondary"
              target="_blank"
              rel="noreferrer"
            >
              <Linkedin size={28} />
            </a>
          )}

          {twitter && (
            <a
              href={twitter}
              className="text-light"
              target="_blank"
              rel="noreferrer"
            >
              <Twitter size={28} />
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutProfilemodule;
